import {
  LOGOUT_SUCCESS,
  SET_DEFAULT_VALUE,
  USER_INFO_LOADING_FAILED,
  USER_INFO_LOADING_SUCCESS,
} from "../actions/types";

const defaultState = {
  userInfo: {},
  error: null,
};
const updateUserInfo = (state, action) => {
  if (!state) {
    return defaultState;
  }

  switch (action.type) {
    case USER_INFO_LOADING_SUCCESS:
      return {
        userInfo: action.payload,
        error: null,
      };
    case USER_INFO_LOADING_FAILED:
      return {
        userInfo: {},
        error: action.payload,
      };
    case LOGOUT_SUCCESS:
    case SET_DEFAULT_VALUE:
      return {
        ...defaultState,
      };
    default:
      return {
        ...state.userInfo,
      };
  }
};

export default updateUserInfo;
